const MAX_TEXT_LENGTH = 120;

function sanitizeValue(value) {
  if (value === null || value === undefined) return undefined;

  if (typeof value === "string") {
    return value.trim().slice(0, MAX_TEXT_LENGTH);
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return value;
  }

  return String(value).slice(0, MAX_TEXT_LENGTH);
}

function sanitizeParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params)
      .map(([key, value]) => [key, sanitizeValue(value)])
      .filter(([, value]) => value !== undefined && value !== ""),
  );
}

export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined") return;
  if (!eventName || typeof window.gtag !== "function") return;

  const payload = sanitizeParams(params);
  window.gtag("event", eventName, payload);
}

export function getPageType(pathname = "") {
  if (!pathname || pathname === "/") return "home";
  if (pathname.startsWith("/posts")) return "posts";
  if (pathname.startsWith("/tutorials")) return "tutorials";
  if (pathname.startsWith("/news")) return "news";
  if (pathname.startsWith("/tools")) return "tools";
  if (pathname.startsWith("/events")) return "events";
  if (pathname.startsWith("/tech-pulse")) return "pulse";
  return "other";
}

export function trackPageContext(pathname = "") {
  const pageType = getPageType(pathname);
  trackEvent("page_context", {
    page_path: pathname || "/",
    page_type: pageType,
  });
}

export function getLinkType(href = "") {
  if (!href) return "unknown";
  if (href.startsWith("#")) return "anchor";
  if (href.startsWith("/")) return "internal";
  if (href.startsWith("mailto:")) return "email";
  if (href.startsWith("tel:")) return "phone";

  try {
    const url = new URL(
      href,
      typeof window !== "undefined" ? window.location.origin : undefined,
    );
    if (
      typeof window !== "undefined" &&
      url.origin === window.location.origin
    ) {
      return "internal";
    }
    return "external";
  } catch {
    return "unknown";
  }
}

export function getLinkDomain(href = "") {
  try {
    const url = new URL(
      href,
      typeof window !== "undefined" ? window.location.origin : undefined,
    );
    return url.hostname;
  } catch {
    return "";
  }
}
